// utils.js

// Function to get a cookie by name
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Function to set a cookie
export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ""}${expires}; path=/`;
};

// Function to delete a cookie by name
export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

// Function to format a number, removing trailing zeros for non-integers
export const formatNumber2 = (number) => {
  const isInteger = Math.floor(number) === number;
  return isInteger ? number.toFixed(0) : parseFloat(number.toFixed(2)).toString();
};

export const formatNumber = (number) => {
    // Check if the number is an integer
    const isInteger = Math.floor(number) === number;

    if (isInteger) {
        // Format as integer (no decimal places)
        return number.toLocaleString(undefined, { maximumFractionDigits: 0 });
    } else {
        // Format with 2 decimal places and remove trailing zeros and decimal point if necessary
        return number
            .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            .replace(/\.?0+$/, '');
    }
}


// Function to calculate Total Daily Energy Expenditure (TDEE)
export const calculateTDEE = (user) => {
  const activityLevels = {
    "sedentary": 1.2,
    "light": 1.375,
    "moderate": 1.55,
    "heavy": 1.725,
    "athlete": 1.9
  };
 
  const dob = new Date(user.date_of_birth);
  const now = new Date();
  const age = now.getFullYear() - dob.getFullYear();

  const bmr = user.gender === "M"
    ? (10 * user.weight) + (6.25 * user.height) - (5 * age) + 5
    : (10 * user.weight) + (6.25 * user.height) - (5 * age) - 161;

 

  const tdee = bmr * activityLevels[user.activity_level];

 

  return tdee;
};

// Function to calculate nutrition goals based on TDEE and user's goal
export const calculateNutritionGoals = (tdee, user) => {
  let adjustment = 1;

  if (user.nutrition_goal !== "maintain") {
    switch (user.nutrition_goal_pace) {
      case "slow":
        adjustment = user.nutrition_goal === "lose" ? 0.9 : 1.05;
        break;
      case "normal":
        adjustment = user.nutrition_goal === "lose" ? 0.8 : 1.1;
        break;
      case "fast":
        adjustment = user.nutrition_goal === "lose" ? 0.75 : 1.15;
        break;
      default:
        adjustment = 1;
    }
  }

  const adjustedTDEE = tdee * adjustment;

  if (user.gender == 'F' || user.gender == 'Female' || user.gender == 'F') {
     var protein = user.weight * 1.7;
  } else {
     var protein = user.weight * 2;
  }

  const fat = user.weight * 0.8;
  const proteinCalories = protein * 4;

  const fatCalories = fat * 9;

  //alert(adjustedTDEE+"--"+proteinCalories+"--"+fatCalories);
  const carbCalories = adjustedTDEE - (proteinCalories + fatCalories);
  const carb = carbCalories / 4;
 
  //alert("final_carb--"+carb);
  return {
    adjustedTDEE: Math.ceil(adjustedTDEE),
    protein: Math.ceil(protein),
    fat: Math.ceil(fat),
    carb: Math.ceil(carb)
  };
};







export const calculateNutritionGoalsNew = (tdee, user) => {  
  const goalConfigs = {
    maintain: {
      coefficient: 1,
      macros: { carbs: 50, protein: 20, fat: 30 }
    },
    lose: {
      slow:    { coefficient: 0.9, macros: { carbs: 45, protein: 30, fat: 25 } },
      normal:  { coefficient: 0.8, macros: { carbs: 40, protein: 35, fat: 25 } },
      fast:    { coefficient: 0.75, macros: { carbs: 40, protein: 40, fat: 20 } }
    },
    gain: {
      slow:    { coefficient: 1.05, macros: { carbs: 50, protein: 25, fat: 25 } },
      normal:  { coefficient: 1.13, macros: { carbs: 55, protein: 25, fat: 20 } },
      fast:    { coefficient: 1.2, macros: { carbs: 60, protein: 25, fat: 15 } }
    }
  };

  let goalConfig; // Declare it before using

  if (user.nutrition_goal === 'maintain') {
    goalConfig = goalConfigs.maintain;
  } else {
    const pace = user.nutrition_goal_pace || 'normal'; // fallback
    goalConfig = goalConfigs[user.nutrition_goal]?.[pace];
  }

  if (!goalConfig) return null;

  const adjustedTDEE = tdee * goalConfig.coefficient;

  const proteinCalories = (goalConfig.macros.protein / 100) * adjustedTDEE;
  const fatCalories = (goalConfig.macros.fat / 100) * adjustedTDEE;
  const carbCalories = (goalConfig.macros.carbs / 100) * adjustedTDEE;

   

  return {
    adjustedTDEE: Math.ceil(adjustedTDEE),
    protein: Math.ceil(proteinCalories / 4),
    fat: Math.ceil(fatCalories / 9),
    carb: Math.ceil(carbCalories / 4)
  };
};




// Function to calculate manual nutrition goals based on user's inputs
export const calculateManualNutritionGoals = (user) => {
  const proteinCalories = user.manual_protein_goal * 4;
  const carbCalories = user.manual_carb_goal * 4;
  const fatCalories = user.manual_fat_goal * 9;
  const adjustedTDEE = proteinCalories + carbCalories + fatCalories;

  return {
    adjustedTDEE: Math.ceil(adjustedTDEE),
    protein: Math.ceil(user.manual_protein_goal),
    fat: Math.ceil(user.manual_fat_goal),
    carb: Math.ceil(user.manual_carb_goal)
  };
};

// Function to calculate calories based on ingredient list
export const calculateCalories = (ingredients, test = 0) => {
    let totalCalories = 0;      

    if (Array.isArray(ingredients)) {
        ingredients.forEach((item) => {
            var qty = item.quantity ?? 1;     
            var proteinCalories = (isNaN(item.protein_per_unit) ? item.protein : item.protein_per_unit) * qty * 4;
            var carbCalories = (isNaN(item.carb_per_unit) ? item.carb : item.carb_per_unit) * qty * 4;
            var fatCalories = (isNaN(item.fat_per_unit) ? item.fat : item.fat_per_unit) * qty * 9;              
            totalCalories += proteinCalories + carbCalories + fatCalories;
        });
    }

    return totalCalories;
};
